export const productPackageFormComponents: Array<string> = [
  'packageName', 'packageType', 'size', 'location', 'articles', 'comment'
]
